import { Table } from 'semantic-ui-react';
import DownloadableFile from '../../../ChemicalProduct/ChemicalProductDetails/GeneralInformation/DownloadableFile';
import { toast } from 'react-toastify';
import { Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { entityType as eType } from '@src/constants';

const FileDownloadableCell = ({ download, rowValues, entryRecord, index, icon, entityType }) => {
  const { t } = useTranslation();
  let fileLinks = [];
  const rowValue = rowValues[entryRecord.key];

  if (rowValue !== 'null' && typeof rowValue !== 'undefined') {
    rowValue.split(';').forEach(file => {
      const fileNameAndId = file.split(':');
      if (fileNameAndId.length > 1) {
        const fileName = fileNameAndId[0];
        const fileID = fileNameAndId[1];
        fileLinks.push(<DownloadableFile fileName={fileName} uploadId={fileID} />);
      }
    });
  }
  const handleCopyDownloadBtn = () => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const productId =
      entityType === eType.product ? rowValues['ID'] : rowValues['GEN_CHEM_PRODUCT_ID'];
    const downloadLink = `${baseUrl}/files/sdsFileDownload/${productId}`;

    navigator.clipboard
      .writeText(downloadLink)
      .then(() => {
        toast.success(
          t('chemical.product.details.page.chemical.container.sds.download.link.copy.success')
        );
      })
      .catch(err =>
        toast.error(
          t('chemical.product.details.page.chemical.container.sds.download.link.copy.error')
        )
      );
  };
  return (
    <Table.Cell
      key={'file_cell_' + index}
      className="tableCell tableCellReducedPadding displayInline"
    >
      {entityType !== eType.inventoryHist && rowValue !== 'null' && fileLinks.length > 0 && (
        <Icon name="share alternate" link onClick={handleCopyDownloadBtn} color="grey" />
      )}
      {rowValue !== 'null' && fileLinks}
    </Table.Cell>
  );
};

export default FileDownloadableCell;
